<template>
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <circle
      cx="18"
      cy="5"
      r="3" />
    <circle
      cx="6"
      cy="12"
      r="3" />
    <circle
      cx="18"
      cy="19"
      r="3" />
    <line
      x1="8.59"
      y1="13.51"
      x2="15.42"
      y2="17.49" />
    <line
      x1="15.41"
      y1="6.51"
      x2="8.59"
      y2="11.49" />
  </svg>
</template>
